import { RootState, store } from "@/redux/store";
import axios, { AxiosInstance } from "axios";

const baseURL =
import.meta.env.VITE_NODE_ENV === "development"
? import.meta.env.VITE_API_BASE_URL_DEV
: import.meta.env.VITE_NODE_ENV === "stage"
? import.meta.env.VITE_API_BASE_URL_STAGE
: import.meta.env.VITE_API_BASE_URL_PROD;

// Create an instance of axios
export const apiClient: AxiosInstance = axios.create({
  baseURL,
  timeout: 10000, // Timeout after 10 seconds
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use(
  (config) => {
    // Get the token from the Redux state
    const token = (store.getState() as RootState).auth.token;

    // If a token exists, set the Authorization header
    if (token) {
      config.headers.Authorization = `${token}`;
    }

    return config;
  },
  (error) => {
    // Handle the error
    return Promise.reject(error);
  }
);